import { Typography } from '@carto/meridian-ds/components'
import { Box } from '@mui/material'
import { useParams } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import { useCheckWorkflowAccess } from 'features/auth-redirect/hooks/authRedirectHooks'
import AuthenticationPrompt from 'app/ui/AuthenticationPrompt'
import WorkflowCanvasBackground from 'features/workflows/ui/Editor/WorkflowCanvasBackground'
import { ResourceType } from 'features/common'

export function WorkflowsLoginPromptUi({ queryResult }) {
  const showBackground = queryResult.data && !queryResult.data?.autoRedirect

  return (
    <>
      {showBackground && <WorkflowCanvasBackground />}
      <AuthenticationPrompt queryResult={queryResult} resourceType={ResourceType.Workflow} logoPositive>
        <Box p={2}>
          <Typography variant="subtitle1">
            <FormattedMessage id="workflows.loginPrompt.title" />
          </Typography>
        </Box>
        <Box px={2} flex={1}>
          <Typography variant="body2" color="textSecondary">
            <FormattedMessage id="workflows.loginPrompt.content" />
          </Typography>
        </Box>
      </AuthenticationPrompt>
    </>
  )
}

export function WorkflowsLoginPrompt() {
  const { workflowId } = useParams()
  const queryResult = useCheckWorkflowAccess(workflowId as string)

  return <WorkflowsLoginPromptUi queryResult={queryResult} />
}
